export default __webpack_public_path__ + "static/media/23_1_3.f822ed2f.png";